import React, { useEffect, useState } from 'react';
import { ReactComponent as CategoryDetailsIcon } from 'assets/icons/brand-details.svg';
import { ReactComponent as AddMealsIcon } from 'assets/icons/meals.svg';
import { Outlet } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import { ROUTE_KEYS } from 'utils/constants';
import RightSidebar from 'components/right-sidebar';
import BottomNavigation from 'components/bottom-navigation';
import useNewAddonContext from 'contexts/new-addon.context';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { SuccessModal } from 'components/base/success-modal';
import { AddonCategoryFormType } from 'contexts/new-addon.context/context';
const NewAddonContent = () => {
  const { newAddonData, setNewAddonData, isValid } = useNewAddonContext();

  const [loading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const { setRightSection, category } = useDashboardContext();
  const MEAL_NAV_LIST = [
    {
      title: 'Addon details',
      link: `${ROUTE_KEYS.NEW_ADDON}/${ROUTE_KEYS.NEW_ADDON_DETAILS}`,
      Icon: CategoryDetailsIcon
    },
    {
      title: 'Preview',
      link: `${ROUTE_KEYS.NEW_ADDON}/${ROUTE_KEYS.NEW_ADDON_PREVIEW}`,
      Icon: AddMealsIcon
    }
  ];
  const handleConfirmForm = async () => {
    const payload = {
      meal_addon_category_ids: newAddonData.meal_addon_category_id,
      item_type: category.toUpperCase(),
      addon_data: [...newAddonData.addons]
    };
    try {
      await apiService.post('marketing/create-addon', { data: payload });
      setShowSuccessModal(true);
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    }
  };

  useEffect(() => {
    setRightSection(<RightSidebar list={MEAL_NAV_LIST} />);

    return () => {
      setRightSection(null);
      setNewAddonData({} as AddonCategoryFormType);
    };
  }, []);

  return (
    <div>
      <Outlet />
      <BottomNavigation
        disabled={!isValid}
        loading={loading}
        list={MEAL_NAV_LIST}
        onConfirm={handleConfirmForm}
      />
      <SuccessModal
        onClose={() => setShowSuccessModal(false)}
        show={showSuccessModal}
        linkText='PROCEED TO HOME'>
        New add-on has been successfully added
      </SuccessModal>
    </div>
  );
};

export default NewAddonContent;
